import { Client } from "../client.model";
import { ClientContactPersonMapper } from "./client-contact-person.mapper";

export class ClientContactPerson {
  constructor(
    public id: number,
    public client: Client,
    public name: string,
    public email: string,
    public phone: string,
    public isActive: boolean,
    public plainPassword: string = null,
  ) {}

  public getId(): number {
    return this.id;
  }

  public setId(param: number) {
    this.id = param;
  }

  public getClient(): Client {
    return this.client;
  }

  public getName(): string {
    return this.name;
  }

  public getEmail(): string {
    return this.email;
  }

  public getPhone(): string {
    return this.phone;
  }

  public setClient(client: Client): void {
    this.client = client;
  }

  public getRequestParams() {
    const returnValues: any = {
      name: this.name,
      email: this.email,
      phone: this.phone,
      isActive: this.isActive,
    };

    if (this.plainPassword) {
      returnValues.plainPassword = this.plainPassword;
    }

    return returnValues;
  }

  public isValid(): boolean {
    return !!this.name && !!this.email;
  }

  public getClone(): ClientContactPerson {
    return ClientContactPersonMapper.map({
      id: this.getId(),
      client: this.client,
      name: this.name,
      email: this.email,
      phone: this.phone,
      isActive: this.isActive,
      plainPassword: this.plainPassword,
    });
  }
}
